





















































import { computed, defineComponent, ref, watch, inject, PropType } from "@vue/composition-api";
import { MessageLinkSubject } from "@scrile/api-provider/dist/api/MessageLinksProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { TipSubjectType } from "@scrile/api-provider/dist/api/TipProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { CREDITS_CURRENCY_CODE } from "@scrile/tools/dist/lib/MoneyHelpers";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { handleRequestError } from "@/lib/handleRequestError";
import { $t } from "@/lib/i18nHelpers";
import { getCurrencySymbol } from "@/lib/moneyHelpers";
import { ROLES } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInput from "@/components/BaseInput";
import BaseSendMessage from "@/components/BaseSendMessage";
import BaseSpinner from "@/components/BaseSpinner";
import PaidActionError from "@/components/PaidActionError";

const NOT_ENOUGH_FUNDS_ERROR = "{com.scrile.money.validation.SpendingBalanceValidator.message}";

export default defineComponent({
  name: "TipController",
  components: { BaseSpinner, BaseSendMessage, BaseInput, BaseIcon, PaidActionError, BaseIconButton },
  props: {
    threadId: { type: String },
    transparent: { type: Boolean, default: false },
    linkSubject: { type: Object as () => MessageLinkSubject },
    subject: { type: Object as PropType<Subject<TipSubjectType>>, required: true },
    recipientId: { type: String },
  },
  setup(props, { emit }) {
    const { authUser } = useAuthUser();
    const data = inject<{ user: UserPublicData | null }>("messageData", { user: null });
    const tipValue = ref("");
    const processing = ref(false);
    const show = ref(false);
    const showPaidError = ref(false);
    const currencySymbol = $t(getCurrencySymbol(CREDITS_CURRENCY_CODE));

    const allowSend = computed(() => tipValue.value.length !== 0 && +tipValue.value > 0);
    const openerIcon = computed(() => (show.value ? "sci-close" : "sci-gift"));
    const activateTip = computed(
      () => checkRole(data.user?.role || "", ROLES.CREATOR) && authUser.value?.id !== data.user?.id
    );

    const toggleShow = () => (show.value = !show.value);

    const tipValueInput = (v: string) => {
      const value = +v;
      if (isNaN(value) || value === 0) {
        tipValue.value = "";
      } else {
        tipValue.value = value.toString();
      }
    };

    const submit = async () => {
      if (!allowSend.value) return;
      try {
        processing.value = true;
        const tipAmount = tipValue.value;
        providers.TipProvider.setReceiveErrors(false);
        await providers.TipProvider.create({
          data: {
            amount: +tipAmount,
            subject: props.subject,
            recipientId: props.recipientId,
          },
        });
        emit("success");
        tipValue.value = "";
        show.value = false;
      } catch (e) {
        handleRequestError(e, [
          {
            comparator: e => e.details?.messageTemplate === NOT_ENOUGH_FUNDS_ERROR,
            onSuccessCB: () => (showPaidError.value = true),
          },
        ]);
      } finally {
        processing.value = false;
        tipValue.value = "";
      }
    };

    watch(show, () => {
      tipValue.value = "";
    });
    return {
      currencySymbol,
      tipValue,
      tipValueInput,
      allowSend,
      processing,
      submit,
      activateTip,
      openerIcon,
      show,
      toggleShow,
      showPaidError,
    };
  },
});
